import { BASE_API, ControllerName } from "../constants"
import { http, pHttp } from "./http";

export class ApiService {

  constructor() {}

  static goods = {
    getBranchOrder: async (bid: number) => {
      return await pHttp.get(this.buildUrl(ControllerName.GOODS, `branch_active/${bid}`))
    },
    payOrder: async (id: number, dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.GOODS, `branch/${id}/pay`), dto)
    },
    checkPayment: async (id: number, gid: number) => {
      return await pHttp.get(this.buildUrl(ControllerName.GOODS, `branch/${id}/pay/${gid}`))
    },
    signIn: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.GOODS, `signin`), dto)
    },
    getStats: async (bid: number) => {
      return await pHttp.get(this.buildUrl(ControllerName.GOODS, `branch/${bid}/stats`))
    },
    getBranchOrders: async (bid: number, query: any) => {
      return await pHttp.get(this.buildUrl(ControllerName.GOODS, `branch_orders/${bid}${this.buildParams(query)}`))
    },
    createOrder: async (bid: number, dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.GOODS, `branch/${bid}/order`), dto)
    },
    deleteOrder: async (bid: number, id: number) => {
      return await pHttp.delete(this.buildUrl(ControllerName.GOODS, `branch/${bid}/order/${id}`))
    }
  }

  static widget = {
    getCompanies: async () => {
      return await pHttp.get(this.buildUrl(ControllerName.WIDGET, `companies`))
    },
    getCompanyStaff: async (cid: number) => {
      return await pHttp.get(this.buildUrl(ControllerName.WIDGET, `companies/${cid}/staff`))
    },
    getServices: async (cid: number) => {
      return await pHttp.get(this.buildUrl(ControllerName.WIDGET, `companies/${cid}/services`))
    },
    getStaffServices: async (cid: number, sid: number) => {
      return await pHttp.get(this.buildUrl(ControllerName.WIDGET, `companies/${cid}/staff/${sid}/services`))
    },
    getStaffInfo: async (cid: number, sid: number) => {
      return await pHttp.get(this.buildUrl(ControllerName.WIDGET, `companies/${cid}/staff/${sid}/info`))
    },
    getStaffDates: async (cid: number, sid: number, date: string) => {
      return await pHttp.get(this.buildUrl(ControllerName.WIDGET, `companies/${cid}/staff/${sid}/dates?date=${date}`))
    },
    getStaffDateTimes: async (cid: number, sid: number, date: string) => {
      return await pHttp.get(this.buildUrl(ControllerName.WIDGET, `companies/${cid}/staff/${sid}/times?date=${date}`))
    },
    createOrder: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.WIDGET, `order`), dto)
    },
    declineOrder: async (order_id: number) => {
      return await pHttp.delete(this.buildUrl(ControllerName.WIDGET, `order/${order_id}`))
    },
    getLastOrder: async () => {
      return await pHttp.get(this.buildUrl(ControllerName.WIDGET, `orders/last`))
    },
    getLastOrders: async () => {
      return await pHttp.get(this.buildUrl(ControllerName.WIDGET, `orders/last_all_x`))
    },
    getUserOrders: async () => {
      return await pHttp.get(this.buildUrl(ControllerName.WIDGET, `orders`))
    },
    findClient: async (phone: string) => {
      return await pHttp.get(this.buildUrl(ControllerName.WIDGET, `client/${phone}`))
    },
    findBarber: async (id: number) => {
      return await pHttp.get(this.buildUrl(ControllerName.WIDGET, `barber/${id}`))
    },
    createTips: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.WIDGET, `order/tips`), dto)
    },
    createReview: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.WIDGET, `order/review`), dto)
    },

    getAllOrders: async (dto: any) => {
      return await pHttp.get(this.buildUrl(ControllerName.WIDGET, `admin/orders/list${this.buildParams(dto)}`))
    },
    getAllReviews: async (dto: any) => {
      return await pHttp.get(this.buildUrl(ControllerName.WIDGET, `admin/reviews/list${this.buildParams(dto)}`))
    },
    getAllTips: async (dto: any) => {
      return await pHttp.get(this.buildUrl(ControllerName.WIDGET, `admin/tips/list${this.buildParams(dto)}`))
    },

    getStats: async () => {
      return await pHttp.get(this.buildUrl(ControllerName.WIDGET, `admin/stats`))
    }
  }

  static branches = {
    getAll: async (source: string = "topgun") => {
      return await pHttp.get(this.buildUrl(ControllerName.BRANCHES, `get${this.buildParams({company: source})}`))
    },
    getBranchesStaffs: async (id: number) => {
      return await pHttp.get(this.buildUrl(ControllerName.BRANCHES, `list/${id}/staffs`))
    },
    getBranch: async (id: number) => {
      return await pHttp.get(this.buildUrl(ControllerName.BRANCHES, `list/${id}`))
    },
    createCountry: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.BRANCHES, `countries`), dto)
    },
    createRegion: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.BRANCHES, `regions`), dto)
    },
    createBranch: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.BRANCHES, `list`), dto)
    },
    updateCountry: async (id: number, dto: any) => {
      return await pHttp.put(this.buildUrl(ControllerName.BRANCHES, `countries/${id}`), dto)
    },
    updateRegion: async (id: number, dto: any) => {
      return await pHttp.put(this.buildUrl(ControllerName.BRANCHES, `regions/${id}`), dto)
    },
    updateBranch: async (id: number, dto: any) => {
      return await pHttp.put(this.buildUrl(ControllerName.BRANCHES, `list/${id}`), dto)
    },
    deleteCountry: async (id: number) => {
      return await pHttp.delete(this.buildUrl(ControllerName.BRANCHES, `countries/${id}`))
    },
    deleteRegion: async (id: number) => {
      return await pHttp.delete(this.buildUrl(ControllerName.BRANCHES, `regions/${id}`))
    },
    deleteBranch: async (id: number) => {
      return await pHttp.delete(this.buildUrl(ControllerName.BRANCHES, `list/${id}`))
    }
  }

  static blog = {
    getList: async () => {
      return await pHttp.get(this.buildUrl(ControllerName.BLOG, `list`))
    },
    createPost: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.BLOG, `list`), dto)
    },
    updatePost: async (id: number, dto: any) => {
      return await pHttp.put(this.buildUrl(ControllerName.BLOG, `list/${id}`), dto)
    },
    deletePost: async (id: number) => {
      return await pHttp.delete(this.buildUrl(ControllerName.BLOG, `list/${id}`))
    }
  }

  static events = {
    register: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.EVENTS, `register`), dto)
    },
    checkPayment: async (id: number) => {
      return await pHttp.get(this.buildUrl(ControllerName.EVENTS, `payment/${id}/check`))
    },
    getCounter: async () => {
      return await pHttp.get(this.buildUrl(ControllerName.EVENTS, `counter`))
    },
    getStats: async (id: number) => {
      return await pHttp.get(this.buildUrl(ControllerName.EVENTS, `list/${id}/stats`))
    },
    getTicket: async (uid: number) => {
      return await pHttp.get(this.buildUrl(ControllerName.EVENTS, `ticket/${uid}`))
    },
    getEvents: async (query: {
      page: number,
      limit: number,
      search: string,
      type: string
    }) => {
      return await pHttp.get(this.buildUrl(ControllerName.EVENTS, `list${this.buildParams(query)}`))
    },
    createEvent: async (dto: any) => {},
    updateEvent: async (id: number, dto: any) => {
      return await pHttp.put(this.buildUrl(ControllerName.EVENTS, `list/${id}`), dto)
    },
    deleteEvent: async (id: number) => {
      return await pHttp.delete(this.buildUrl(ControllerName.EVENTS, `list/${id}`))
    },
    getMembers: async (query: {
      event_id: number,
      page: number,
      limit: number,
      search: string,
      order: string,
      orderBy: string,
      grouped: string,
      type: string,
      status: string
    }) => {
      return await pHttp.get(this.buildUrl(ControllerName.EVENTS, `members${this.buildParams(query)}`))
    },
    getUserDuples: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.EVENTS, `members/${dto.user_id}`), dto)
    },
    createMember: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.EVENTS, `members`), dto)
    },
    updateMember: async (id: number, dto: any) => {
      return await pHttp.put(this.buildUrl(ControllerName.EVENTS, `members/${id}`), dto)
    },
    deleteMember: async (id: number) => {
      return await pHttp.delete(this.buildUrl(ControllerName.EVENTS, `members/${id}`))
    },
    findTicket: async (data: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.EVENTS, `find`), {data})
    },
    sendTicket: async (uid: number, eid: number) => {
      return await pHttp.get(this.buildUrl(ControllerName.EVENTS, `account/${uid}/ticket/${eid}`))
    },
    sendTicketSMS: async (uid: number, eid: number) => {
      return await pHttp.get(this.buildUrl(ControllerName.EVENTS, `account/${uid}/ticket_sms/${eid}`))
    }
  }

  static loyalty = {
    getNotifies: async (query: any) => {
      return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `notifies_my${this.buildParams(query)}`))
    },
    getNews: async (query: any) => {
      return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `news_my${this.buildParams(query)}`))
    },

    makePayment: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `cloudpayments/create`), dto)
    },

    getAccountById: async (id: number) => {
      return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `account/byid/${id}`))
    },

    getMyWallets: async () => {
      return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `wallets`))
    },
    createWallet: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `wallets`), dto)
    },
    deleteWallet: async (id: number) => {
      return await pHttp.delete(this.buildUrl(ControllerName.LOYALTY, `wallets/${id}`))
    },
    selectWallet: async (id: number) => {
      return await pHttp.put(this.buildUrl(ControllerName.LOYALTY, `wallets/${id}`), {})
    },

    getReferalBonus: async (bonus: number, random: number) => {
      return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `bonus_ref?bonus=${bonus}&random=${random}`), {})
    },

    openChest: async (line: number) => {
      return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `open_chest?line=${line}`), {})
    },

    getBarbersTop: async () => {
      return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `top/barbers`))
    },

    getReferalPrize: async () => {
      return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `account/referal/prize`), {})
    },
    signInWithTelegram: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `signin_tgx`), dto)
    },
    
    getClients: async (params: any) => {
      return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `clients${this.buildParams(params)}`))
    },
    getClientById: async (id: number) => {
      return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `clients/${id}`))
    },

    
    createOrderReview: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `orders/review`), dto)
    },
    updateOrderReview: async (id: number, dto: any) => {
      return await pHttp.put(this.buildUrl(ControllerName.LOYALTY, `orders/review/${id}`), dto)
    },
    deleteOrderReview: async (id: number) => {
      return await pHttp.delete(this.buildUrl(ControllerName.LOYALTY, `orders/review/${id}`))
    },
    adjustBalance: async (id: number, dto: {
      phone: string
      adjust: {
        amountDelta: number
        expirationPeriodDays: number
        comment: string
        notify: boolean
      }
    }) => {
      return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `account/${id}/adjust`), dto)
    },
    checkAccount: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `auth/check_sign`), dto)
    },
    signInWithCode: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `auth/code`), dto)
    },
    signUpWithMaxma: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `auth/signup`), dto)
    },
    getAccount: async () => {
      return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `account`));
    },
    getAccountBonusHistory: async () => {
      return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `account/bonus_history`));
    },
    getAccountNewBonuses: async () => {
      return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `account/bonx`))
    },
    updateAccount: async (id: number, dto: any) => {
      return await pHttp.put(this.buildUrl(ControllerName.LOYALTY, `account`), dto);
    },
    deleteAccount: async (id: number) => {
      return await pHttp.delete(this.buildUrl(ControllerName.LOYALTY, `account/${id}`));
    },

    barbers: {
      getBarberComments: async (company_id: number, barber_id: number) => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `barber/comments/${company_id}/${barber_id}`))
      },
      getAllCommentsAboutClient: async () => {},
      createBarberComment: async () => {}
    },

    tickets: {
      getStats: async () => {
        return await pHttp.get(this.buildUrl(ControllerName.TICKETS, `stats`))
      },
      getMyTickets: async () => {
        return await pHttp.get(this.buildUrl(ControllerName.TICKETS, `my`))
      },
      getMyTicketsCount: async () => {
        return await pHttp.get(this.buildUrl(ControllerName.TICKETS, `count`))
      },
      getTourneys: async () => {
        return await pHttp.get(this.buildUrl(ControllerName.TICKETS, `tourneys`))
      },
      getTourney: async (id: number) => {
        return await pHttp.get(this.buildUrl(ControllerName.TICKETS, `tourneys/${id}`))
      },
      createTourney: async (dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.TICKETS, `tourneys`), dto)
      },
      updateTourney: async (id: number, dto: any) => {
        return await pHttp.put(this.buildUrl(ControllerName.TICKETS, `tourneys/${id}`), dto)
      },
      deleteTourney: async (id: number) => {
        return await pHttp.delete(this.buildUrl(ControllerName.TICKETS, `tourneys/${id}`))
      },
      acceptTickets: async (dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.TICKETS, `accept`), dto)
      },
      adjustTickets: async (dto: any) => {},
      createTicket: async (dto: any) => {},
      deleteTickets: async (dto: any) => {},
      buyTickets: async (dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.TICKETS, `buy`), dto)
      },
    },

    adjusterAction: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `adjuster`), dto)
    },

    statuses: {
      getMyStatus: async () => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `statuses/my`))
      },
      updateStatus: async (dto: any) => {
        return await pHttp.put(this.buildUrl(ControllerName.LOYALTY, `statuses/my`), dto)
      },
      selectPrizeForStatus: async (dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `statuses/gift`), dto)
      },
      monthlyStatusesTask: async () => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `statuses/task`))
      }
    },

    promos: {
      generateUniqueCode: async () => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `promos/unique`))
      },
      getPromos: async () => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `promos/list`))
      },
      getPromo: async (id: number) => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `promos/list/${id}`))
      },
      createPromo: async (dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `promos/list`), dto)
      },
      updatePromo: async (id: number, dto: any) => {
        return await pHttp.put(this.buildUrl(ControllerName.LOYALTY, `promos/list/${id}`), dto)
      },
      deletePromo: async (id: number) => {
        return await pHttp.delete(this.buildUrl(ControllerName.LOYALTY, `promos/list/${id}`))
      },

      getPromoCodes: async (pid: number, query: any) => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `promos/codes/${pid}${this.buildParams(query)}`))
      },
      createManyCodes: async (dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `promos/codes`), dto)
      },
      createPromoCode: async (dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `promos/code`), dto)
      },
      updatePromoCode: async (id: number, dto: any) => {
        return await pHttp.put(this.buildUrl(ControllerName.LOYALTY, `promos/code/${id}`), dto)
      },
      deletePromoCode: async (id: number) => {
        return await pHttp.delete(this.buildUrl(ControllerName.LOYALTY, `promos/code/${id}`))
      },
      activatePromoCode: async (dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `promos/activate`), dto)
      }
    },
    
    yclients: {
      getVisits: async (query: any) => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `yclients/user_records${this.buildParams(query)}`))
      },
      getOrders: async (query: any) => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `yclients/user_orders${this.buildParams(query)}`))
      },
      getVisitsByIds: async (dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `yclients/user_visits`), dto)
      }
    },

    stats: {
      getBasicStats: async () => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `stats/basic`))
      },
      getBonusStats: async (query: any) => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `stats/bonus${this.buildParams(query)}`))
      },
      getBonusHistory: async (query: any) => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `stats/bonus/history${this.buildParams(query)}`))
      },
      getClientsStats: async (query: any) => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `stats/clients${this.buildParams(query)}`))
      }
    },

    favs: {
      getFavs: async () => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `favorites`))
      },
      createFav: async (dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `favorites`), dto)
      },
      updateFav: async (id: number, dto: any) => {
        return await pHttp.put(this.buildUrl(ControllerName.LOYALTY, `favorites/${id}`), dto)
      },
      deleteFav: async (id: number) => {
        return await pHttp.delete(this.buildUrl(ControllerName.LOYALTY, `favorites/${id}`))
      }
    },

    wishes: {
      getWishes: async () => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `wishes_all`))
      },
      getMyWishes: async () => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `wishes`))
      },
      createWish: async (dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `wishes`), dto)
      },
      updateWish: async (id: number, dto: any) => {
        return await pHttp.put(this.buildUrl(ControllerName.LOYALTY, `wishes/${id}`), dto)
      },
      deleteWish: async (id: number) => {
        return await pHttp.delete(this.buildUrl(ControllerName.LOYALTY, `wishes/${id}`))
      }
    },

    cats: {
      getCats: async () => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `cats`))
      },
      getCategory: async (id: number) => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `cats/${id}`))
      },
      createCategory: async (dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `cats`), dto)
      },
      updateCategory: async (id: number, dto: any) => {
        return await pHttp.put(this.buildUrl(ControllerName.LOYALTY, `cats/${id}`), dto)
      },
      deleteCategory: async (id: number) => {
        return await pHttp.delete(this.buildUrl(ControllerName.LOYALTY, `cats/${id}`))
      },
    },

    stories: {
      getAll: async () => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `stories`))
      },
      lookStory: async (id: number) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `stories/look/${id}`), {})
      },
      createStory: async (dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `stories`), dto)
      },
      updateStory: async (id: number, dto: any) => {
        return await pHttp.put(this.buildUrl(ControllerName.LOYALTY, `stories/${id}`), dto)
      },
      deleteStory: async (id: number) => {
        return await pHttp.delete(this.buildUrl(ControllerName.LOYALTY, `stories/${id}`))
      }
    },

    subscribes: {
      activateBase: async (uid: number) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `account/${uid}/activate_base`), {})
      },
      createSub: async (uid: number, dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `account/${uid}/subscribe`), dto)
      },
      createBotSub: async (uid: number, dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `account/${uid}/bot`), dto)
      },
      updateSub: async (uid: number, sid: number, dto: any) => {
        return await pHttp.put(this.buildUrl(ControllerName.LOYALTY, `account/${uid}/subscribe/${sid}`), dto)
      },
      updateBotSub: async (uid: number, sid: number, dto: any) => {
        return await pHttp.put(this.buildUrl(ControllerName.LOYALTY, `account/${uid}/bot/${sid}`), dto)
      },
      deleteSub: async (uid: number, sid: number) => {
        return await pHttp.delete(this.buildUrl(ControllerName.LOYALTY, `account/${uid}/subscribe/${sid}`))
      },
      deleteBotSub: async (uid: number, sid: number) => {
        return await pHttp.delete(this.buildUrl(ControllerName.LOYALTY, `account/${uid}/bot/${sid}`))
      },

      cancelSub: async (uid: number) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `account/${uid}/subscribe/cancel`))
      },
      cancelBotSub: async (uid: number) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `account/${uid}/bot/cancel`))
      },

      createPayment: async (dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `orders/payment/sub`), dto)
      }
    },

    store: {
      parse: async (dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `store/parse`), dto)
      },
      getProductAdds: async (pid: number) => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `store/adds/${pid}`))
      },
      getProductVars: async (pid: number) => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `store/vars/${pid}`))
      },
      getList: async (params: any) => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `store/list${this.buildParams(params)}`))
      },
      getStock: async (id: number, page: number, limit: number) => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `store/list/stock/${id}${this.buildParams({page, limit})}`))
      },
      addToStock: async (pid: number, dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `store/list/stock/${pid}/add`), dto)
      },
      writeFromStock: async (pid: number, dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `store/list/stock/${pid}/write`), dto)
      },
      getProductById: async (id: number) => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `store/list/bi/${id}`))
      },
      getProductByName: async (linkname: string) => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `store/list/bl/${linkname}`))
      },
      createProduct: async (dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `store/list`), dto)
      },
      updateProduct: async (id: number, dto: any) => {
        return await pHttp.put(this.buildUrl(ControllerName.LOYALTY, `store/list/${id}`), dto)
      },
      deleteProduct: async (id: number) => {
        return await pHttp.delete(this.buildUrl(ControllerName.LOYALTY, `store/list/${id}`))
      }
    },

    orders: {
      getMy: async (params: any) => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `orders${this.buildParams(params)}`))
      },
      getList: async (params: any) => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `orders/list${this.buildParams(params)}`))
      },
      getOrderById: async (id: number) => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `orders/list/${id}`))
      },
      createOrder: async (dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `orders/list`), dto)
      },
      updateOrder: async (id: number, dto: any) => {
        return await pHttp.put(this.buildUrl(ControllerName.LOYALTY, `orders/list/${id}`), dto)
      },
      deleteOrder: async (id: number) => {
        return await pHttp.delete(this.buildUrl(ControllerName.LOYALTY, `orders/list/${id}`))
      },
      createPayment: async (dto: any) => {
        return await pHttp.post(this.buildUrl(ControllerName.LOYALTY, `orders/payment`), dto)
      },
      checkPayment: async (id: number) => {
        return await pHttp.get(this.buildUrl(ControllerName.LOYALTY, `orders/payment/status/${id}`))
      }
    }
  }

  static users = {
    signIn: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.USERS, `signin`), dto);
    },
    signUp: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.USERS, `signup`), dto);
    },
    getAccount: async () => {
      return await pHttp.get(this.buildUrl(ControllerName.USERS, `account`));
    },
    getAccountById: async (id: number) => {
      return await pHttp.get(this.buildUrl(ControllerName.USERS, `account/byid/${id}`));
    },
    updateAccount: async (dto: any) => {
      return await pHttp.put(this.buildUrl(ControllerName.USERS, `account`), dto);
    },
    getUsers: async (params: any) => {
      return await pHttp.get(this.buildUrl(ControllerName.USERS, `list${this.buildParams(params)}`));
    },
    getAllUsers: async () => {
      return await pHttp.get(this.buildUrl(ControllerName.USERS, `list/all`));
    },
    getLostedUsers: async () => {
      return await pHttp.get(this.buildUrl(ControllerName.USERS, `list/losted`));
    },
    findTicket: async (data: string) => {
      return await pHttp.post(this.buildUrl(ControllerName.USERS, `find`), {data});
    },
    getTicket: async (id: number) => {
      return await pHttp.get(this.buildUrl(ControllerName.USERS, `ticket/${id}`));
    },
    updateUser: async (id: number, dto: any) => {
      return await pHttp.put(this.buildUrl(ControllerName.USERS, `account/${id}`), dto);
    },
    deleteUser: async (id: number) => {
      return await pHttp.delete(this.buildUrl(ControllerName.USERS, `account/${id}`));
    },
    sendTicket: async (id: number) => {
      return await pHttp.post(this.buildUrl(ControllerName.USERS, `account/${id}/ticket`));
    },

    getJournal: async (query: any) => {
      return await pHttp.get(this.buildUrl(ControllerName.USERS, `journal${this.buildParams(query)}`))
    },
    getUserJournal: async (user_id: number, query: any) => {
      return await pHttp.get(this.buildUrl(ControllerName.USERS, `journal/${user_id}${this.buildParams(query)}`))
    }
  }

  static core = {
    getSettings: async () => {
      return await pHttp.get(this.buildUrl(ControllerName.CORE, `settings`));
    },
    updateSetting: async (id: number, dto: any) => {
      return await pHttp.put(this.buildUrl(ControllerName.CORE, `settings/${id}`), dto);
    },
    sendMail: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.CORE, `sendmail`), dto)
    },
    getSuggestions: async (query: any) => {
      return await pHttp.get(this.buildUrl(ControllerName.CORE, `suggestions${this.buildParams(query)}`));
    }
  }

  static crm = {
    getTables: async () => {
      return await pHttp.get(this.buildUrl(ControllerName.CRM, `tables`))
    },
    createTable: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.CRM, `tables`), dto)
    },
    updateTable: async (id: number, dto: any) => {
      return await pHttp.put(this.buildUrl(ControllerName.CRM, `tables/${id}`), dto)
    },
    deleteTable: async (id: number) => {
      return await pHttp.delete(this.buildUrl(ControllerName.CRM, `tables/${id}`))
    },
    getTable: async (id: number, page: number, limit: number, search: string) => {
      return await pHttp.get(this.buildUrl(ControllerName.CRM, `tables/${id}${this.buildParams({page, limit, search})}`))
    },
    createColumn: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.CRM, `cols`), dto)
    },
    updateColumn: async (id: number, dto: any) => {
      return await pHttp.put(this.buildUrl(ControllerName.CRM, `cols/${id}`), dto)
    },
    deleteColumn: async (id: number) => {
      return await pHttp.delete(this.buildUrl(ControllerName.CRM, `cols/${id}`))
    },
    createTicket: async (dto: any) => {
      return await pHttp.post(this.buildUrl(ControllerName.CRM, `tickets`), dto)
    },
    updateTicket: async (id: number, dto: any) => {
      return await pHttp.put(this.buildUrl(ControllerName.CRM, `tickets/${id}`), dto)
    },
    deleteTicket: async (id: number) => {
      return await pHttp.delete(this.buildUrl(ControllerName.CRM, `tickets/${id}`))
    }
  }

  static buildUrl(
    controller: ControllerName,
    method: string
  ) {
    return `${BASE_API}${controller}/${method}`
  }

  static buildParams(map: any) {
    let query = "";
    for (let key in map) {
      if (query == "") {
        query = `?${key}=${map[key]}`;
      } else {
        query += `&${key}=${map[key]}`;
      }
    }
    return query;
  }
}